import { endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const createEcomSubCategory = (_, params) => {
  return Api(endPoints.createEcomSubCategory, params, requestType.POST);
};

const getAllEcomSubCategory = (name, categoryId = "All", lang = "") => {
  return Api(
    `${endPoints.getAllEcomSubCategory}?name=${
      name || ""
    }&categoryId=${categoryId}&lang=${lang}`,
    null,
    requestType.GET
  );
};

const updateEcomSubCategory = (id, params) => {
  return Api(
    `${endPoints.updateEcomSubCategory}/${id}`,
    params,
    requestType.PUT
  );
};

const deleteEcomSubCategory = (id) => {
  return Api(
    `${endPoints.deleteEcomSubCategory}/${id}`,
    null,
    requestType.DELETE
  );
};

const updateEcomSubCategoryStatus = (id, params) => {
    return Api(`${endPoints.updateEcomSubCategoryStatus}/${id}`, params, requestType.PATCH);
};

export {
  createEcomSubCategory,
  getAllEcomSubCategory,
  updateEcomSubCategory,
  deleteEcomSubCategory,
  updateEcomSubCategoryStatus,
};
